import React from 'react';
import Layout from '../components/layout';
import Content from '../components/content';

const Work = () => (
    <Layout>
        <nav style={{ gridColumn: '1 / -1' }}>
            <h4>Work</h4>
            <ul>
                <li>
                    <Content kind="h3" tag="h3">
                        Stripe (2025&mdash;2026)
                    </Content>
                </li>
                <li>
                    <Content kind="h3" tag="h3">
                        {/* <a href="./github">GitHub (2022&mdash;2023)</a> */}
                        GitHub (2022&mdash;2023)
                    </Content>
                </li>
                <li>
                    <Content kind="h3" tag="h3">
                        {/* <a href="./github">GitHub (2022&mdash;2023)</a> */}
                        Docplanner (2021&mdash;2022)
                    </Content>
                </li>
                <li>
                    <Content kind="h3" tag="h3">
                        <a href="./new-relic">New Relic (2019&mdash;2021)</a>
                    </Content>
                </li>
                <li>
                    <Content kind="h3" tag="h3">
                        <a href="./typeform">Typeform (2017&mdash;2019)</a>
                    </Content>
                </li>
                <li>
                    <Content kind="h3" tag="h3">
                        <a href="./playfulbet">Playfulbet (2015&mdash;2017)</a>
                    </Content>
                </li>
            </ul>
            <h4>Web projects</h4>
            <ul>
                <li>
                    <Content kind="h3" tag="h3">
                        <a href="https://boringavatars.com/">Boring avatars</a>
                    </Content>
                </li>
                <li>
                    <Content kind="h3" tag="h3">
                        <a href="https://www.boringvectors.com/">Boring vectors</a>
                    </Content>
                </li>
            </ul>
            <h4>Others</h4>
            <ul>
                <li>
                    <Content kind="h3" tag="h3">
                        <a href="https://www.pastisserialamenuda.cat//">La menuda</a>
                    </Content>
                </li>
                <li>
                    <Content kind="h3" tag="h3">
                        <a href="https://www.enrojecerse.com/">Enrojecerse</a>
                    </Content>
                </li>
                <li>
                    <Content kind="h3" tag="h3">
                        <a href="https://www.43hilosworkshop.com//">43 Hilos</a>
                    </Content>
                </li>
            </ul>
            <h4>Photography</h4>
            <ul>
                <li>
                    <Content kind="h3" tag="h3">
                        <a href="https://unsplash.com/@josepmartins">Textures</a>
                    </Content>
                </li>
                <li>
                    <Content kind="h3" tag="h3">
                        <a href="https://www.instagram.com/josepmartins/">Instagram</a>
                    </Content>
                </li>
            </ul>
        </nav>
    </Layout>
);

export default Work;
